/* ASK A VET(TM) Free Tools gateway — Shopify section */
(function () {
  "use strict";

  function init(root) {
    if (!root || root.dataset.initialized === "true") return;
    root.dataset.initialized = "true";
  }

  function initAll() {
    document.querySelectorAll("s-free-tools-page").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector("s-free-tools-page")
      : null;
    init(root);
  });
})();
